import { createGlobalStyle } from 'styled-components';
import { media } from './breakpoints';
import { colors } from './colors';

export const GlobalStyle = createGlobalStyle`
  @font-face {
		font-family: 'LT Saeada';
		font-style: normal;
		font-weight: normal;
    font-named-instance: 'Regular';
		src: url(/fonts/LTSaeada-Regular.woff) format('woff');
	}

	@font-face {
		font-family: 'LT Saeada';
		font-style: normal;
		font-weight: 500;
    font-named-instance: 'Medium';
		src: url(/fonts/LTSaeada-Medium.woff) format('woff');
	}

	@font-face {
		font-family: 'LT Saeada';
		font-style: normal;
		font-weight: 600;
    font-named-instance: 'SemiBold';
		src: url(/fonts/LTSaeada-SemiBold.woff) format('woff');
	}
  html {
    scroll-behavior: smooth;
  }

  html,
  body,
  ___gatsby,
  ___gatsby > div {
    font-family: 'Lexend', 'Roboto', 'Noto Sans', 'Helvetica Neue', Arial, sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 156%;
    letter-spacing: 0%;

    margin: 0;
    padding: 0;
    overflow-x: hidden;
    color: ${colors.white};
    background: ${colors.black};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  h1 {
    font-family: 'Lt Saeada', -apple-system,
      BlinkMacSystemFont, 'Segoe UI', Roboto,
      Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue',
      sans-serif;
    font-weight: 700;
  }

  a {
    text-decoration: none;
  }

  button.osano-cm-widget {
    display: none;
  }

  .osano-cm-dialog--type_box.osano-cm-dialog--position_bottom-right {
    bottom: unset;
    right: unset;
    max-width: unset;
    width: 100%;
    background: #FFFFFF;

    ${media.md`
      bottom: 1em;
      right: 1em;
      max-width: 20em;
      width: calc(100vw - 2em);
      background: rgba(255,255,255,0.7);
    `}
    .os-close-btn {
      background: white;
      border: 1px solid;
      cursor: pointer;
      padding: 8px;
      width: 100%;
      border-radius: 0.25em;
      margin-top: 12px;
      font-weight: 600;
      font-size: 15px;
    }
  }
`;
